import { TransactionType } from './invoice-for-currency-for-legal-entity.model';

export enum DocumentVersionType {
  ORIGINAL = 'ORIGINAL',
  COPY_OF_ORIGINAL = 'COPY_OF_ORIGINAL'
}

export interface Invoice {
  id: string;
  type: TransactionType;
  createDate: string;
  dueDate?: string;
  settlementDate?: string;
  billedSum: InvoiceAmount;
  legalEntity: string;
  documentId: number;
  eInvoiceId?: string;
}

export interface InvoiceAmount {
  amount: number;
  currency: string;
}

export interface InvoiceQueryParams {
  identifier?: string;
  dateFrom?: string;
  dateUntil?: string;
  isOpen?: boolean;
  currency?: string;
  page: number;
  size?: number;
}

export interface InvoiceToDownload {
  invoiceId: number | string;
  documentId: number;
  date: string;
  type: TransactionType;
  eInvoiceId?: string;
}
